import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useState, useEffect, useReducer } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { asignarSecuencia } from "../../services/nomina-secuencias-service";
import SelectController from "../../../../core/ui/components/SelectController";

import { useForm } from "react-hook-form";
import SecuenciaTurnos from "./secuencia-turnos";
import Button from "../../../../core/ui/components/Button";
import { asignarEmpleadosReducer } from "../../reducers/asignar-empleados-reducer";
import { selectEmpleadosSinReglasOSecuencias } from "../../../Personas/services/empleados-service";

const FormAsignarSecuencias = ({ modalState }) => {
    const { secuencia } = modalState.data;
    const [opcionesEmpleados, setOpcionesEmpleados] = useState([]);
    const [empleados, accionEmpleados] = useReducer(
        asignarEmpleadosReducer,
        []
    );

    const form = useForm({ defaultValues: { empleados: "" } });

    useEffect(async () => {
        const sinReglas = await selectEmpleadosSinReglasOSecuencias(
            secuencia.id,
            "secuencias"
        );

        if (!sinReglas.status) return toast.error(sinReglas.message);

        const empleados = sinReglas.data.map((empleado) => {
            return {
                persona_id: empleado.id,
                info_persona: empleado.info_persona,
                label: empleado.info_persona,
                value: empleado.id,
            };
        });

        setOpcionesEmpleados(empleados);
        accionEmpleados({
            tipo: "llenar",
            valor: secuencia.empleados,
        });
    }, [secuencia]);

    const onSubmit = async () => {
        const resp = await asignarSecuencia(secuencia.id, empleados);

        if (!resp.status) return toast.error(resp.message);
        modalState.set({ show: false });
        toast.success(resp.message);
    };

    const agregarEmpleados = () => {
        const empleados = form.getValues("empleados");

        accionEmpleados({
            tipo: "agregar",
            valor: empleados ?? [],
            idSecuencia: secuencia.id,
        });
    };

    const onEliminarAsignacion = (idPersona) => {
        accionEmpleados({
            tipo: "eliminar",
            valor: idPersona,
        });
    };

    const onSeleccionTurno = (indiceTurno, idEmpleado) => {
        accionEmpleados({
            idEmpleado,
            indiceTurno,
            tipo: "seleccionar_turno",
        });
    };

    return (
        <FormModal
            size="xl"
            form={form}
            isOpen={modalState.show}
            onSubmit={onSubmit}
            id="formAsignarSecuencia"
            closeModal={() => modalState.set({ show: false })}
            headerTitle="Asignar Secuencia"
        >
            <p>
                <strong>Secuencia:</strong> {secuencia.nombre}
            </p>
            <SecuenciaTurnos
                secuencia={secuencia.secuencia_turnos_sedes ?? []}
            />
            <Row className="mt-5">
                <Col sm={10}>
                    <SelectController
                        isMulti={true}
                        name="empleados"
                        options={opcionesEmpleados}
                        control={form.control}
                        errors={form.formState.errors}
                        placeholder="Seleccionar Empleado..."
                    />
                </Col>
                <Col md={2}>
                    <Button onClick={agregarEmpleados}>
                        <i className="fas fa-plus mr-2"></i>
                        Agregar
                    </Button>
                </Col>
            </Row>

            <div className="overflow-auto">
                {empleados.map((empleado) => {
                    return (
                        <div
                            className="mt-1 pl-4 border d-flex justify-content-between align-items-center"
                            key={empleado.persona_id}
                        >
                            <div>{empleado.info_persona}</div>
                            <div className="secuencias-empleados">
                                <SecuenciaTurnos
                                    secuencia={secuencia.secuencia_turnos_sedes}
                                    indiceSeleccionado={
                                        empleado.posicion_arranca_secuencia
                                    }
                                    onSeleccionTurno={(indice) =>
                                        onSeleccionTurno(
                                            indice,
                                            empleado.persona_id
                                        )
                                    }
                                />
                                <div
                                    className="d-inline-block"
                                    onClick={() =>
                                        onEliminarAsignacion(empleado.persona_id)
                                    }
                                >
                                    <i className="fas fa-trash mr-2 text-danger"></i>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </FormModal>
    );
};

FormAsignarSecuencias.propTypes = {
    modalState: PropTypes.object,
};

export default FormAsignarSecuencias;
